import gql from 'graphql-tag';

const FRAGMENT = gql`
  fragment Referral on referrals {
    id
    referral_code
    google_tokens
  }
`;

export const GET_REFERRAL = gql`
  query getRefferal($userId: Int!) {
    referrals(where: { user_id: { _eq: $userId } }) {
      ...Referral
    }
  }
  ${FRAGMENT}
`;

export const CREATE_REFERRAL = gql`
  mutation addReferral($data: referrals_insert_input!) {
    insert_referrals_one(object: $data) {
      ...Referral
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_REFERRAL = gql`
    mutation updateReferral($id: Int!, $data: referrals_set_input!) {
        update_referrals_by_pk(pk_columns: {id: $id}, _set: $data) {
            ...Referral
        }
    }
    ${FRAGMENT}
`;
